import { useTranslation } from 'react-i18next';
import SelectField from '../../core/components/Fields/SelectField.tsx';
import * as React from 'react';
import { DOCUMENT_NUMBER_FALLBACK_OPTIONS } from '../constants.ts';

const DocumentNumberFallbackSelectField = (props: React.ComponentPropsWithRef<typeof SelectField>) => {
    const { t } = useTranslation('config');

    return (
        <SelectField
            {...props}
            options={DOCUMENT_NUMBER_FALLBACK_OPTIONS.map(({ value, labelKey }) => ({ label: t(labelKey), value }))}
        />
    );
};

export default DocumentNumberFallbackSelectField;
